import { EnumUserType } from 'models/User';
import store from 'store';
interface CustomerIdFilterProps {
  customerId: {
    eq: string;
  };
}

export const FilterDataSelectedCustomerOData = (props?: any) => {

  const { user } = store.getState();

  const existSelectedCustomer: Array<string> | string = user?.selectedCustomerId!;

  if (!existSelectedCustomer) return;

  if (Array.isArray(user?.selectedCustomerId)) {

    const multipleCompanies: Array<string> = user?.selectedCustomerId!;
    const customerIdFilter: Array<CustomerIdFilterProps> = [];

    multipleCompanies?.forEach((customerId: string) => {
      customerIdFilter.push({
        customerId: { eq: customerId }
      });
    });

    return { or: customerIdFilter, ...props };
  }

  if (!Array.isArray(user?.selectedCustomerId)) {
    return {
      customerId: user?.selectedCustomerId, ...props
    };
  }
};

export const FilterDataSelectedCustomer = (props?: any) => {

  const { user } = store.getState();
  const { openProtocolCustomer } = store.getState();
  const { customer } = store.getState();

  if (user?.userType === EnumUserType.CUSTOMER) {
    return user?.selectedCustomerId?.toString();
  }

  return openProtocolCustomer?.id || customer?.id;
};